import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { posteingangApi } from '../api';

export default function InboxWidget() {
  const [summary, setSummary] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    posteingangApi.summary().then(setSummary).catch(() => {});
  }, []);

  if (!summary) return null;

  const { gesamt, ZU_PRUEFEN, FEHLER, ZUGEORDNET } = summary;
  if (gesamt === 0) return null;

  return (
    <div style={{
      background: '#1e293b', borderRadius: 12, padding: '18px 20px',
      border: '1px solid #334155', marginBottom: 16
    }}>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 12 }}>
        <span style={{ fontWeight: 700, fontSize: 15, color: '#f1f5f9' }}>📥 Posteingang</span>
        <button
          onClick={() => navigate('/posteingang')}
          style={{
            padding: '4px 14px', borderRadius: 20, border: '1px solid #818cf8',
            background: '#1e1b4b', color: '#818cf8', fontWeight: 600, fontSize: 13, cursor: 'pointer'
          }}
        >
          Öffnen →
        </button>
      </div>

      <div style={{ display: 'flex', gap: 12, flexWrap: 'wrap' }}>
        {ZU_PRUEFEN > 0 && (
          <div style={{
            background: '#422006', borderRadius: 8, padding: '8px 14px',
            flex: 1, minWidth: 100, textAlign: 'center'
          }}>
            <div style={{ fontWeight: 700, fontSize: 22, color: '#fbbf24' }}>{ZU_PRUEFEN}</div>
            <div style={{ fontSize: 12, color: '#94a3b8' }}>Zu prüfen</div>
          </div>
        )}
        {FEHLER > 0 && (
          <div style={{
            background: '#431407', borderRadius: 8, padding: '8px 14px',
            flex: 1, minWidth: 100, textAlign: 'center'
          }}>
            <div style={{ fontWeight: 700, fontSize: 22, color: '#f87171' }}>{FEHLER}</div>
            <div style={{ fontSize: 12, color: '#94a3b8' }}>Fehler</div>
          </div>
        )}
        <div style={{
          background: '#052e16', borderRadius: 8, padding: '8px 14px',
          flex: 1, minWidth: 100, textAlign: 'center'
        }}>
          <div style={{ fontWeight: 700, fontSize: 22, color: '#34d399' }}>{ZUGEORDNET || 0}</div>
          <div style={{ fontSize: 12, color: '#94a3b8' }}>Zugeordnet</div>
        </div>
        <div style={{
          background: '#0f172a', borderRadius: 8, padding: '8px 14px',
          flex: 1, minWidth: 100, textAlign: 'center'
        }}>
          <div style={{ fontWeight: 700, fontSize: 22, color: '#94a3b8' }}>{gesamt}</div>
          <div style={{ fontSize: 12, color: '#64748b' }}>Gesamt</div>
        </div>
      </div>

      {ZU_PRUEFEN > 0 && (
        <div style={{
          marginTop: 12, padding: '8px 12px', background: '#422006',
          borderRadius: 8, fontSize: 13, color: '#fdba74',
          display: 'flex', alignItems: 'center', gap: 8, flexWrap: 'wrap'
        }}>
          ⚠️ <strong>{ZU_PRUEFEN} Dokument(e)</strong> warten auf manuelle Vertragszuordnung.
          <button
            onClick={() => navigate('/posteingang?status=ZU_PRUEFEN')}
            style={{
              marginLeft: 6, padding: '2px 10px', borderRadius: 12,
              border: '1px solid #f59e0b', background: '#1e293b', color: '#fbbf24',
              cursor: 'pointer', fontWeight: 600, fontSize: 12
            }}
          >
            Jetzt prüfen
          </button>
        </div>
      )}
    </div>
  );
}
